import {
  CounterDraft,
  CounterReadyToSend,
  DocumentsList,
  EntitiesBase,
  ErrorPayload,
  GetSearchParams,
  IntegrationRequestsList,
  SendingRequest,
} from '@domain/types';
import { createAction, PayloadAction } from '@reduxjs/toolkit';

import { SendingRequestID } from './documents.state';

type Ids = { ids: SendingRequestID[] };

export type BatchDownloadDocumentsPayload = Ids & { fileName?: string };
export type BatchDownloadDocumentsAction = PayloadAction<BatchDownloadDocumentsPayload>;
export type BatchDownloadDocumentsFailureAction = PayloadAction<ErrorPayload>;

/**
 * Search params
 */

export type UpdateSearchParamsPayload = GetSearchParams;
export type UpdateSearchParamsAction = PayloadAction<UpdateSearchParamsPayload>;

/**
 * Entities
 */
export type UpdateEntitiesPayload = EntitiesBase;
export const updateEntitiesAction = createAction<UpdateEntitiesPayload>(`UpdateEntities`);
/**
 * Fetch Documents
 */

export type FetchDocumentsPayload = GetSearchParams & {
  currentIdentity?: string;
  clearIdentity?: boolean;
};
export type FetchDocumentsSuccessPayload = DocumentsList & {
  moreBefore?: boolean;
  moreAfter?: boolean;
};

export type FetchDocumentsSuccessFromCachePayload = { documents: SendingRequest[]; total: number };

export type FetchErrorsDocumentsPayload = FetchDocumentsPayload & { showRead?: boolean };
export type FetchDocumentsAction = PayloadAction<FetchErrorsDocumentsPayload>;
export type FetchDocumentsSuccessAction = PayloadAction<FetchDocumentsSuccessPayload>;
export type FetchDocumentsFailureAction = PayloadAction<ErrorPayload>;
export type FetchDocumentsFromCacheSuccessAction =
  PayloadAction<FetchDocumentsSuccessFromCachePayload>;

export type FetchTotalReadyToSendPayload = CounterReadyToSend;
export type FetchTotalReadyToSendSuccessAction = PayloadAction<FetchTotalReadyToSendPayload>;
export type FetchTotalReadyToSendFailureAction = PayloadAction<ErrorPayload>;

export type FetchTotalDraftPayload = CounterDraft;
export type FetchTotalDraftSuccessAction = PayloadAction<FetchTotalDraftPayload>;
export type FetchTotalDraftFailureAction = PayloadAction<ErrorPayload>;

export type UpdateTotalDraftOrReadyToSendPayload = { identity: string | undefined; count: number };
export type IncrementTotalDraftAction = PayloadAction<UpdateTotalDraftOrReadyToSendPayload>;
export type IncrementTotalReadyToSendAction = PayloadAction<UpdateTotalDraftOrReadyToSendPayload>;

export type SetCurrentIdentityPayload = {
  identity: string;
};
export type SetCurrentIdentityAction = PayloadAction<SetCurrentIdentityPayload>;

export type FetchIntegrationRequestSuccessPayload = IntegrationRequestsList & {
  moreBefore?: boolean;
  moreAfter?: boolean;
};

export type FetchIntegrationRequestsSuccessAction =
  PayloadAction<FetchIntegrationRequestSuccessPayload>;

export type OneSuccessPayload = { id: SendingRequestID };
export type OneSuccessAction = PayloadAction<OneSuccessPayload>;

export type FailureAction = PayloadAction<ErrorPayload>;
